export function SelectedLayerVisibilityNotice({ notice, onTurnVisibilityOn }) {
  if (!notice) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed left-1/2 top-4 z-[45] -translate-x-1/2 rounded-md border border-white/15 bg-gray-950/85 px-3 py-1.5 text-xs font-medium text-gray-100 shadow-lg"
    >
      {notice.message} Turn {notice.visibilityLabel} visibility{" "}
      <button type="button" className="toast-link pointer-events-auto" onClick={onTurnVisibilityOn}>
        on
      </button>
      .
    </div>
  );
}
